module.exports = __webpack_public_path__ + "static/media/mbys_sel_iso.8dc08f64.png";